export default "__VITE_ASSET__3WvJDgtE__"